import styled from '@emotion/styled';
import media from 'css-in-js-media';

export const StyledBlogList = styled.div`
  list-style: none;
  max-width: 870px;
  max-height: 130px;
  margin: 0 auto 37px auto;
  display: flex;
  overflow: hidden;

  ${media('<desktop')} {
    margin: 0 0 20px 0;
    max-height: 64px;
  }
`;

export const StyledBlogListContent = styled.div`
  padding: 0 0 0 30px;
`;
